import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "dot", "radio"]
  declare readonly optionTargets: HTMLElement[]
  declare readonly dotTargets: HTMLElement[]
  declare readonly radioTargets: HTMLInputElement[]

  connect() {
    this.highlightSelected()
  }

  selectOption(event: Event) {
    const option = event.currentTarget as HTMLElement
    const value = option.dataset.languageSelectValue

    const radio = this.radioTargets.find((r) => r.value === value)
    if (radio) {
      radio.checked = true
      radio.dispatchEvent(new Event("change", { bubbles: true }))
      this.highlightSelected()

      this.element.dispatchEvent(
        new CustomEvent("language-changed", {
          bubbles: true,
          detail: { language: value },
        }),
      )
    }
  }

  highlightSelected() {
    const selected = this.radioTargets.find((r) => r.checked)?.value

    for (const option of this.optionTargets) {
      option.dataset.selected = String(option.dataset.languageSelectValue === selected)
    }

    for (const dot of this.dotTargets) {
      const isSelected = dot.dataset.code === selected
      dot.classList.toggle("opacity-100", isSelected)
      dot.classList.toggle("opacity-0", !isSelected)
    }
  }
}
